import api from 'operations/config/api';

export default function shipmentEmergencyService(url) {
  return api.post(`${url}`, {});
}
